import Box from '@mui/material/Box';
import LaunchSoon from '../sharedComps/LaunchSoon';

const Blogs = () => {

    return <Box id="Blog" className="container" sx={{ width: 'auto', background:'#A9C4EB', p: {xs: 3.5, md: 7.5}, border: '1px outset' }}>
        <Box component="h1" mt={0} className='text-shadow text-white'>Blog</Box>
        <LaunchSoon />
    </Box>
}

export default Blogs;
